export default () => {
  if ($('#dropdown-sort').length) {
    (($) => {
      $('#dropdown-sort').on('click', function () {
        $('#dropdown-content-sort').slideToggle('slow');
      });
    })(jQuery);
  }
};
